import { useState, useEffect, useMemo } from "react";
import styles from "./Navbar.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import MobileSaleBanner from "./TopOfferBanner";
import { X } from "lucide-react";
const Navbar = (props) => {
  const { header: headerProp, onBannerClick, isVisible } = props;
  const data = props?.header?.header ?? props?.header ?? null;
  const [menuOpen, setMenuOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  const endTime = "2025-11-30T23:59:59";

  const navigate = useNavigate();
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [menuOpen]);

  const isExternal = (href = "") => /^https?:\/\//i.test(href);
  const navLinks = Array.isArray(data?.navLinks) ? data.navLinks : [];
  const cta = data?.cta;
  const logo = data?.logo;

  const handleCTA = (cta) => {
    if (!cta?.url) return;
    setMenuOpen(false);

    const external = isExternal(cta.url);

    if (external) {
      if (cta.newTab) {
        window.open(cta.url, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = cta.url;
      }
      return;
    }

    if (cta.newTab) {
      window.open(cta.url, "_blank", "noopener,noreferrer");
    } else {
      navigate(cta.url);
    }
  };

  const target = useMemo(() => toMs(endTime), [endTime]);
  const [remaining, setRemaining] = useState(() =>
    Math.max(0, target - Date.now())
  );

  useEffect(() => {
    const id = setInterval(() => {
      setRemaining((prev) => {
        const next = Math.max(0, target - Date.now());
        if (next === 0 && prev === 0) {
          clearInterval(id);
        }
        return next;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [target]);

  function toMs(t) {
    if (t instanceof Date) return t.getTime();
    if (typeof t === "string") {
      const ms = new Date(t).getTime();
      return Number.isNaN(ms) ? NaN : ms;
    }

    return typeof t === "number" ? t : NaN;
  }

  const pad = (n) => String(n).padStart(2, "0");

  const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

  const timeStr = `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     if (window.innerWidth < 768) {
  //       setVisible(true);
  //     } else {
  //       setVisible(false);
  //     }
  //   }
  // }, []);
  return (
    <>
      {visible  && (
        <>
          <div className="hidden md:block">
            <div className={styles.hederpart}>
              <div
                className={styles.Formarquediv}
                onClick={() => {
                  if (onBannerClick) onBannerClick();
                }}
              >
                <div className={styles.marqueeMain}>
                  <span className="top-offer-bannerR">
                    Launch Offer: <span className={styles.offer}>30% OFF</span>
                     {/* Holiday Week OFF: <span className={styles.offer}>30% OFF</span> */}
                  </span>
                </div>

                <div className={styles.counterMain}>
                  <span
                    className={styles.timerChip}
                    aria-label={`Time remaining ${timeStr}`}
                  >
                    <div className={styles.timebar}>
                      <svg
                        className={styles.clock}
                        viewBox="0 0 24 24"
                        width="18"
                        height="18"
                        aria-hidden="true"
                      >
                        <path
                          d="M12 8v5l3 1"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          cx="12"
                          cy="13"
                          r="8"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                        <path
                          d="M8 2h8M12 2v3"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                      <span className={styles.time}>{timeStr}</span>
                    </div>
                  </span>

                  <div className={styles.CrossDiv}>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        setVisible(false);
                      }}
                      className="text-white hover:text-gray-200"
                      aria-label="Close banner"
                    >
                      <X className={styles.cross} size={16} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="block md:hidden"
            onClick={() => {
              if (onBannerClick) onBannerClick();
            }}
          >
            <MobileSaleBanner styleOverride={{ display: "flex" }} />
          </div>
        </>
      )}
      {/* <div className="hidden md:block">
        <div className={styles.thanksgiving}>
          <img
            src="./Images/thanksgiving-Icon.svg"
            alt="Launch-Offer"
            onClick={() => {
              if (onBannerClick) onBannerClick();
            }}
          />
        </div>
      </div> */}

      <div
        className={`${visible ? styles.navMainWithBanner : styles.navMain} ${
          menuOpen ? styles.menuOpen : ""
        }`}
      >
        <nav className={styles.navbar}>
          {/* Logo */}
          <div className={styles.logo}>
            <NavLink to="/" onClick={() => setMenuOpen(false)}>
              {logo?.src ? (
                <img src={logo.src} alt={logo.alt || "Logo"} />
              ) : (
                <img src="/Svg/rexpt-logo.svg" alt="rexpt-logo" />
              )}
            </NavLink>
          </div>

          {/* Menu Links */}
          <ul className={`${styles.navLinks} ${menuOpen ? styles.open : ""}`}>
            {navLinks.map((item) => {
              const key = item?._key || item?.href || item?.label;
              if (!item?.href) return null;
              if (isExternal(item.href)) {
                return (
                  <li key={key}>
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => setMenuOpen(false)}
                    >
                      {item?.label || "Link"}
                    </a>
                  </li>
                );
              }

              return (
                <li key={key}>
                  <NavLink
                    to={item.href}
                    className={({ isActive }) =>
                      isActive ? styles.activeLink : ""
                    }
                    onClick={() => setMenuOpen(false)}
                  >
                    {item?.label || "Link"}
                  </NavLink>
                </li>
              );
            })}
          </ul>

          {/* Right Section */}
          <div className={styles.right}>
            <button
              type="button"
              className={styles.startBtn}
              onClick={() => handleCTA(data?.cta)}
            >
              {data?.cta?.label || "Get Started"}
            </button>

            <div
              className={`${styles.hamburger} ${menuOpen ? styles.active : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span></span>
              <span></span>
            </div>
          </div>
        </nav>
      </div>

      {menuOpen && (
        <div
          className={styles.overlay}
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </>
  );
};

export default Navbar;
